import React from 'react';
import http from '@/services/http';
import { CLIENT_URL } from './urls';

class ClientController extends React.Component {
	getAll = async (url, cityId) => {
		// console.log("getAllClients", cityId);
		let data;

		try {
			const res = await http.get(`${CLIENT_URL}${cityId || ''}`);
			// console.log("clients", res?.data?.clients || res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			clients: data.clients,
		};
	};

	searchClients = async ({ cityId, searchText }) => {
		// console.log('getAllClients', cityId)
		let data;

		// console.log("search ", `${CLIENT_URL}search-clients/${cityId || ""}`);
		try {
			const res = await http.get(`${CLIENT_URL}search-clients/${cityId || ''}`, {
				searchText,
			});
			// console.log("clients", res?.data?.clients || res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			clients: data?.clients,
		};
	};

	add = async (client, cityId) => {
		// console.log("addclient");
		let data;

		try {
			const res = await http.post(`${CLIENT_URL}${cityId || ''}`, { client });
			// console.log("res from add", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	edit = async (clientId, client) => {
		// console.log("editclient", clientId);
		let data;

		try {
			const res = await http.put(`${CLIENT_URL}${clientId}`, { client });
			// console.log("res from put", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};

	delete = async clientId => {
		// console.log("deleteclient");
		let data;

		try {
			const res = await http.delete(`${CLIENT_URL}${clientId}`);
			// console.log("res from deleteclient", res);
			data = res?.data;
		} catch (error) {
			console.log(error);
			return {
				error: true,
			};
		}

		return {
			...data,
		};
	};
}

const clientController = new ClientController();

export default clientController;
